export default __webpack_public_path__ + "static/media/Untitled-4-min.7343574f.png";